import { getStorageItem } from "@/libs/local-storage";

const REMEMBER_ME_KEY = "njorda.auth.remember-me";
const LOGGED_IN_KEY = "njorda.auth.logged-in";
const REMEMBER_ME_TRUE_VALUE = "1";
const REMEMBER_ME_FALSE_VALUE = "0";
const defaultRoute = "/auth/welcome";

/**
 * Here we will detect if it's a first time run and we should show welcome screen
 * or user already been authenticated and we can show `welcome back`/login screen
 */

const loggedIn = ref(getStorageItem(LOGGED_IN_KEY) ?? false);

export default function useAuth() {
    const { $setStorageItem, $getStorageItem, $removeStorageItem } = useNuxtApp();

    const setRememberMe = (shouldRemember: boolean) => {
        $setStorageItem(
            REMEMBER_ME_KEY,
            shouldRemember ? REMEMBER_ME_TRUE_VALUE : REMEMBER_ME_FALSE_VALUE,
        );
    };

    const getRememberMe = () => {
        return $getStorageItem(REMEMBER_ME_KEY) === REMEMBER_ME_TRUE_VALUE;
    };

    const setLoggedIn = () => {
        loggedIn.value = true;
        $setStorageItem(LOGGED_IN_KEY, true);
    }

    const clearLoggedIn = () => {
        loggedIn.value = false;
        $removeStorageItem(LOGGED_IN_KEY);
    }

    return {
        defaultRoute,
        loggedIn,
        setRememberMe,
        getRememberMe,
        setLoggedIn,
        clearLoggedIn,
    };
}
